import { gql, useQuery } from "@apollo/client";
import moment from "moment";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, IndexTable, Layout, Page, Pagination } from "@shopify/polaris";
import { Graph } from "src/generated/graph";
import { PolarisCard } from "src/components/shopify/PolarisCard";
import TextField from "src/components/shopify/form/TextField";

const query_search_break_down = gql`
  query reportSearchBreakdown($start: String!, $end: String!) {
    reportSearchBreakdown(start: $start, end: $end)
  }
`;

type StateProp = {
  start: string;
  end: string;
  startInput: string;
  endInput: string;
};

export function SearchScreen() {
  const { t } = useTranslation();
  const date = new Date();
  const end = moment(date).format("YYYY-MM-DD");
  const start = moment(date.setDate(date.getDate() - 1)).format("YYYY-MM-DD");
  const [state, setState] = useState<StateProp>({
    end,
    start,
    startInput: start,
    endInput: end,
  });
  const [offset, setOffset] = useState(0);

  const { data, loading, error } = useQuery<Graph.Query>(query_search_break_down, {
    fetchPolicy: "no-cache",
    variables: {
      start: state.start,
      end: state.end,
    },
  });

  const onClickFilter = () => {
    setState({
      ...state,
      start: state.startInput,
      end: state.endInput,
    });
  };

  if (error) {
    return <>{error.message}</>;
  }

  const length = data ? data.reportSearchBreakdown.keywords.length || 0 : 0;

  return (
    <Page title="" titleHidden fullWidth>
      <Layout>
        <Layout.Section variant="oneThird">
          <PolarisCard padding={"0"}>
            <br />
            <Box paddingInline={"500"}>
              <form>
                <div style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap", width: 200 }}>
                  <div>
                    <TextField
                      label={t("from")}
                      labelHidden
                      type="date"
                      value={state.startInput}
                      onChange={(v) => setState({ ...state, startInput: v })}
                      autoComplete="off"
                      prefix={t("from")}
                    />
                  </div>
                  <div className="mr-2 ml-2">
                    <TextField
                      label={t("to")}
                      labelHidden
                      type="date"
                      value={state.endInput}
                      onChange={(v) => setState({ ...state, endInput: v })}
                      autoComplete="off"
                      prefix={t("to")}
                    />
                  </div>
                  <div>
                    <button type="button" className="btn btn-primary btn-sm" onClick={onClickFilter}>
                      <i className="os-icon os-icon-refresh-ccw"></i>
                      <span>{t("filter_now")}</span>
                    </button>
                  </div>
                </div>
              </form>
            </Box>
            <Box padding={"300"} paddingInline={"500"}>
              <Pagination
                hasNext={(offset + 1) * 25 < length}
                hasPrevious={offset > 0}
                onNext={() => setOffset(offset + 1)}
                onPrevious={() => setOffset(offset - 1)}
                label={`${offset * 25 || 1}-${(offset + 1) * 25} of ${length} keywords`}
              />
            </Box>
            <Box padding={"0"}>
              <IndexTable
                headings={[{ title: "#" }, { title: t("keyword") }]}
                itemCount={data ? data.reportSearchBreakdown.keywords.length || 0 : 0}
                selectable={false}
                loading={loading}
              >
                {data &&
                  data.reportSearchBreakdown.keywords
                    .filter((_: any, i: any) => i >= offset * 25 && i < offset * 25 + 25)
                    .map((x: any, i: number) => {
                      return (
                        <IndexTable.Row key={i} id={i + ""} position={i}>
                          <IndexTable.Cell>
                            <small>{offset * 25 + i + 1}</small>
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <Link to={"/preview/product?search=" + x.keyword}>
                              <small>{x.keyword}</small>
                            </Link>
                          </IndexTable.Cell>
                        </IndexTable.Row>
                      );
                    })}
              </IndexTable>
            </Box>
          </PolarisCard>
        </Layout.Section>
        <Layout.Section variant="oneHalf"></Layout.Section>
        {/* <Layout.Section variant="oneThird"></Layout.Section> */}
      </Layout>
    </Page>
  );
}
